import { Label, Shimmer, ShimmerElementType, Text } from "@fluentui/react";

export const PlaceHolderControl: React.FunctionComponent<{
    label?: string,
    onClick?: () => void,
    loading?: boolean
}> = (props) => {


    return <div style={{ minHeight: '58px' }} onClick={props.onClick}>
        <Label>{props.label}</Label>
        {!props.loading &&
            <div>
                <Text block styles={{ root: { color: 'gray', marginTop:'6px' } }} variant={"small"}>click here to enable modification</Text>
            </div>
        }
        {props.loading &&
            <Shimmer
                shimmerElements={[{ type: ShimmerElementType.line, height: 22, width: '60px' }]}
                width='60px'
            />
        }
    </div>
}

export default PlaceHolderControl;